import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M960,112.941176 C492.875294,112.941176 112.941176,492.875294 112.941176,960 C112.941176,1427.12471 492.875294,1807.05882 960,1807.05882 C1427.12471,1807.05882 1807.05882,1427.12471 1807.05882,960 C1807.05882,492.875294 1427.12471,112.941176 960,112.941176 M960,1920 C430.644706,1920 0,1489.35529 0,960 C0,430.644706 430.644706,0 960,0 C1489.35529,0 1920,430.644706 1920,960 C1920,1489.35529 1489.35529,1920 960,1920 M1377.90494,1344.04518 L903.552,988.280471 L903.552,395.339294 L1016.49318,395.339294 L1016.49318,931.809882 L1445.66965,1253.57929 L1377.90494,1344.04518 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconClockLine = /*#__PURE__*/function (_Component) {
  _inherits(IconClockLine, _Component);

  var _super = _createSuper(IconClockLine);

  function IconClockLine() {
    _classCallCheck(this, IconClockLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconClockLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconClock",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconClockLine.displayName = "IconClockLine";
  return IconClockLine;
}(Component);

IconClockLine.glyphName = 'clock';
IconClockLine.variant = 'Line';
IconClockLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconClockLine;
export { IconClockLine };